export default () => ({
    active: 0,
    mouseX: 0,
    mouseY: 0,
    arrowType: 'left',
    showCursor: false,
    duration: 4000,
    total: null,
    autoplay: true,
    
    init() {
      // this.start();
    },
    
    start() {
      this.autoplay = setInterval(() => {
        this.next();
      }, this.duration);
    },

    updateMouse(e) {
      this.mouseX = e.clientX;
      this.mouseY = e.clientY;
      // console.log(window);
      if(this.total > 0) {
        this.showCursor = true;
        if(this.mouseX > window.innerWidth /2) {
          this.arrowType = 'right';
        } else {
          this.arrowType = 'left';
        }
      }
    },

    handleClick() {
      // console.log('handleClick');
      clearInterval(this.autoplay);

      if(this.arrowType == 'left') {
        this.prev()
      } else {
        this.next();
      }
    },

    next() {
      // console.log('next');
      // console.log($el);
      if(this.active == this.total) {
        this.active = 0;
      } else {
        this.active = this.active + 1;
      }
      // this.imgHeight = Math.floor($el.querySelectorAll('.slider_slide')[this.active].getBoundingClientRect().height);
    },

    prev() {
      // console.log('prev');
      if(this.active == 0) {
        this.active = this.total;
      } else {
        this.active = this.active - 1;
      }
      // this.imgHeight = Math.floor($el.querySelectorAll('.slider_slide')[this.active].getBoundingClientRect().height);
    }
    
})